var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "currentColor",
    clipRule: "currentColor",
    d: "M7.49935 3.3335C7.95959 3.3335 8.33268 2.9604 8.33268 2.50016C8.33268 2.03992 7.95959 1.66683 7.49935 1.66683H2.49935C2.03911 1.66683 1.66602 2.03992 1.66602 2.50016C1.66602 2.9604 2.03911 3.3335 2.49935 3.3335H7.49935ZM10.8327 8.3335C11.2929 8.3335 11.666 7.9604 11.666 7.50016C11.666 7.03992 11.2929 6.66683 10.8327 6.66683H2.49935C2.03911 6.66683 1.66602 7.03992 1.66602 7.50016C1.66602 7.9604 2.03911 8.3335 2.49935 8.3335H10.8327ZM14.166 13.3335C14.6263 13.3335 14.9993 12.9604 14.9993 12.5002C14.9993 12.0399 14.6263 11.6668 14.166 11.6668H2.49935C2.03911 11.6668 1.66602 12.0399 1.66602 12.5002C1.66602 12.9604 2.03911 13.3335 2.49935 13.3335H14.166ZM17.4993 18.3335C17.9596 18.3335 18.3327 17.9604 18.3327 17.5002C18.3327 17.0399 17.9596 16.6668 17.4993 16.6668H2.49935C2.03911 16.6668 1.66602 17.0399 1.66602 17.5002C1.66602 17.9604 2.03911 18.3335 2.49935 18.3335H17.4993Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default __webpack_public_path__ + "static/media/sortDesc.e670e97d.svg";
export { ForwardRef as ReactComponent };